export const PARTNER_BANK_ACCOUNTS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerBankAccountsUpdated";
export const PARTNER_BANK_ACCOUNTS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerBankAccountsInvalidated";
